// extracted by mini-css-extract-plugin
export default {"footerContainer":"FooterComponent_footerContainer__MP4vl","footerContent":"FooterComponent_footerContent__+IkS+"};